<template>
  <div class="clearfix">
    <form-thum-file
      v-for="(file, index) in files"
      :key="index"
      :name="`${name}-${index}`"
      :index="index"
      :error="error"
      :url="url"
      :uuid="uuid"
      :files="files"
      :readonly="readonly"
      :limit="limit"
      :accept="accept"
      :uploadStatus="uploadStatus"
      @removeFile="(value) => $emit('removeFile', value)"
      @error="(value) => $emit('error', value)"
      @fileUpload="(value) => $emit('fileUpload', value)"
    ></form-thum-file>

    <form-thum-file
      v-if="limit > files.length"
      :name="`${name}-${files.length}`"
      :index="files.length"
      :error="error"
      :url="url"
      :uuid="uuid"
      :files="files"
      :readonly="readonly"
      :helpText="helpText"
      :helpHtml="helpHtml"
      :limit="limit"
      :accept="accept"
      :uploadStatus="uploadStatus"
      @removeFile="(value) => $emit('removeFile', value)"
      @error="(value) => $emit('error', value)"
      @fileUpload="(value) => $emit('fileUpload', value)"
    ></form-thum-file>
    <form-error
      :error="error"
      :name="name"
    ></form-error>
    <help-text :label="helpText"></help-text>
  </div>
</template>

<script>
export default {
  props: {
    name: { type: String, required: true },
    error: { type: Object, required: true },
    url: { type: String, required: true },
    uuid: { type: String, required: true },
    files: { type: Array, required: true },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    helpText: { type: String, default: '' },
    helpHtml: { type: String, default: '' },
    limit: { type: Number, default: 1 },
    uploadStatus: { type: String, default: '' },
    accept: { type: Array }
  },
  components: {
    FormError: () => import('@/component/ui2/form/FormError'),
    HelpText: () => import('@/component/ui2/common/HelpText'),
    FormThumFile: () => import('@/component/ui2/form/FormThumFile')
  }
}
</script>
